export default {
  async sendActivationMail() {}
}
